import { GraphSchema } from '@ta/server';

export interface Address {
  id: string;
  street: string;
  number: string;
  city: string;
  zipCode: string;
  floor: string;
  country: string;
}

export const addressBrutProps: (keyof Address)[] = [
  'id',
  'street',
  'number',
  'zipCode',
  'city',
  'floor',
  'country',
];

export const addressProps = new GraphSchema<Address>(addressBrutProps);

export const addressPropsComposition = `
  ${addressProps.get('id')}
  ${addressProps.get('street')}
  ${addressProps.get('number')}
  ${addressProps.get('zipCode')}
  ${addressProps.get('city')}
  ${addressProps.get('floor')}
  ${addressProps.get('country')}
`;
